import Tastet from '../tastet.js';
import Header from '../views/header.js';
import Search from '../views/search.js';
import Modal from '../views/modal.js';
import RegionModal from '../views/region-modal.js';
import Slider from '../views/slider.js';
import Form from '../views/form.js';
import More from '../views/more.js';
import Reveal from '../views/reveal.js';
import Map from '../views/map.js';
import Sticky from '../views/sticky.js';
import VideoGallery from '../views/video-gallery.js';
import Select from '../views/select.js';

export default class Page extends Tastet.Module {
  // static ------------------------------------------------------------------
  /**
   * Find the proper Page Class if it exists (with the help of the "data-load-js" attribute)
   */
  static create() {
    var $el = this.$('[data-load-js]');

    // Si aucun élément trouvé, utiliser #app comme fallback
    if (!$el.length) {
      $el = this.$('#app');
    }

    // Si toujours aucun élément, utiliser body
    if (!$el.length) {
      $el = this.$('body');
    }

    var data = $el.data() || {};
    var page = Tastet.Pages[data.loadJs];

    if (!page && data.loadJs) {
      var filename = this.utils.string.camel2dash(data.loadJs);
      this.require('page/' + filename + '.js', _load);
    } else {
      _load();
    }

    function _load() {
      console.log('Creating page instance with:', $el, data);
      Tastet.page = new (Tastet.Pages[data.loadJs] || Tastet.Modules.Page)($el, data);
    }

    // Communicate with parent window if we're in an iframe
    console.log('pageChange', window.location.href);
    if (window.parent !== window) {
      window.parent.postMessage(
        {
          type: 'pageChange',
          url: window.location.href,
          timestamp: Date.now(),
        },
        '*'
      );
    }
  }

  // init --------------------------------------------------------------------
  preInit($el, data) {
    // Vérifier que $el est valide et est un objet jQuery
    if (!$el || !$el.jquery) {
      $el = this.$('body');
    }

    // Vérifier que data est un objet
    if (!data || typeof data !== 'object') {
      data = {};
    }

    this.$element = $el.length ? $el : this.$('body');

    // modules
    this.header = new Header('[data-module="header"]');
    this.search = new Search('[data-module="search"]');

    // add global scanning of modules
    this.addScan('modules', (el, args) => {
      var lazy = args && args.lazy;

      // refresh current modules
      this.$(el)
        .find('[data-module]')
        .each(function (child) {
          var view = child.__view__ || {};
          view.refresh && view.refresh();
        });

      // parse modules
      Modal.find(el, '[data-module="modal"]', lazy);
      RegionModal.find(el, '[data-module="region-modal"]', lazy);
      Slider.find(el, '[data-module="slider"]', lazy);
      Map.find(el, '[data-module="map"]', lazy);
      Form.find(el, '[data-module="form"]', lazy);
      More.find(el, '[data-module="more"]', lazy);
      Reveal.find(el, '[data-module="reveal"]', lazy);
      Sticky.find(el, '[data-module="sticky"]', lazy);
      VideoGallery.find(el, '[data-module="video-gallery"]', lazy);
      Select.find(el, '[data-module="select"]', lazy);

    });

    this.scan(this.$element);

    this.addEmbeddedClass();
    this.addPremiumClass();
    this.prepGTM();
  }

  preMount() {
    this.isLoading(false);
    super.preMount();
  }

  // events ------------------------------------------------------------------

  // modules -----------------------------------------------------------------

  // methods -----------------------------------------------------------------
  prepGTM() {
    // pass pageview custom dimensions
    window.dataLayer = window.dataLayer || [];
    const gtmData = {
      event: 'page_loaded',
      templateName: Tastet.settings.template,
    };
    if (Tastet.settings.merchant_name) {
      gtmData.merchantName = Tastet.settings.merchant_name;
    }
    window.dataLayer.push(gtmData);
  }

  addEmbeddedClass() {
    try {
      const isEmbedded =
        Tastet.settings.is_embedded ||
        (sessionStorage && sessionStorage.getItem('is_embedded') === 'true') ||
        window.location.search.includes('is_embedded=true');

      if (isEmbedded) {
        // Save the is_embedded value in session storage
        sessionStorage.setItem('is_embedded', 'true');
        this.$('body').addClass('is-embedded');
        // Remove is_embedded=true from the URL if it exists and keep the other parameters
        const url = new URL(window.location.href);
        url.searchParams.delete('is_embedded');
        window.history.replaceState({}, '', url.toString());
      }
    } catch (error) {
      console.error('Error adding embedded class', error);
    }
  }

  addPremiumClass() {
    try {
      const isPremium =
        Tastet.settings.is_premium ||
        (sessionStorage && sessionStorage.getItem('is_premium') === 'true') ||
        window.location.search.includes('is_premium=true');

      if (isPremium) {
        // Save the is_premium value in session storage
        sessionStorage.setItem('is_premium', 'true');
        this.$('body').addClass('is-premium');
        // Remove is_premium=true from the URL if it exists and keep the other parameters
        const url = new URL(window.location.href);
        url.searchParams.delete('is_premium');
        window.history.replaceState({}, '', url.toString());
      }
    } catch (error) {
      console.error('Error adding premium class', error);
    }
  }
}

// Cache the module in the global
Tastet.Modules.Page = Page;
